
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import GridForm from "@/components/general/GridForm.vue";
import {globalEventBus} from "@/main";

@Component({
    components: {GridForm},
})
export default class Products extends Vue {
    @Prop({default: false})
    private isTransmitting!: boolean;
    private gridName = 'BROWSE_FILIALARTIKEL';
    private canCreate = false;
    private loading = false;

    mounted() {
        globalEventBus.$on("transferChanged", this.transferChanged);
    }

    destroyed() {
        globalEventBus.$off("transferChanged", this.transferChanged);
    }

    constructor() {
        super();
    }

    private formObjectChanged() {
        // bewusst leer: @onFormObjectChanged wird gebunden, aber nicht ausgewertet
    }

    private filter = '';
    private singleSelectActions: any[] = [];

    private multiSelectEnabled(entries: any[]): boolean {
        return entries.length > 0;
    }

    private multiSelectActions: any[] = [{
        icon: '<i aria-hidden="true" class="v-icon notranslate posmanager posmanager-cash-register-input-output theme--light" style="font-size: 12px;"></i>',
        displayName: 'Artikel senden',
        action: async (entries: any[]) => {
            if (this.multiSelectEnabled(entries)) {
                globalEventBus.$emit("showConfirm", {
                    title: "Artikel übertragen",
                    message: "Die Aktualisierung der Artikel kann mehrere Minuten in Anspruch nehmen.\n" +
                        "Soll die Übertragung der Artikeldaten jetzt gestartet werden?",
                    confirmationCallback: async () => {
                        try {
                            this.loading = true;
                            const selected: any[] = [];
                            entries.forEach(
                                (e) => {
                                    selected.push({RECORDID: e.id});
                                })
                            try {
                                await this.$ports.posManager.sendArticleList(selected);
                                (this.$refs.grid as GridForm).clearSelection();
                                globalEventBus.$emit('transferChanged', {
                                    isTransmitting: true,
                                    title: "Artikel"
                                });

                            } catch (e: any) {
                                globalEventBus.$emit("showError", e.message);
                            }
                        } catch (e: any) {
                            globalEventBus.$emit("showError", e.message);
                        } finally {
                            this.loading = false;
                        }

                    }
                });
            }
        },
        enabled: () => this.sendArticleEnabled
    }];

    // [{
    //     icon: '<i class="fas fa-print mr-2"></i>',
    //     displayName: 'Alle Drucken',
    //     action: () => alert('print all'),
    // }, {
    //     icon: '<i class="fas fa-trash mr-2"></i>',
    //     displayName: 'Alle Stornieren',
    //     action: () => alert('cancel all'),
    // }];
    @Watch('isTransmitting')
    private isTransmittingChanged() {
        if (!this.isTransmitting) {
            (this.$refs.grid as GridForm).refresh(true);
        }
    }

    @Watch('branchId')
    private branchChanged() {
        this.$router.go(0);
    }

    private async transferChanged(args: { isTransmitting: boolean, title: string }) {
        console.log("transferChanged: " + this.isTransmitting);
        this.$emit('update:isTransmitting', args.isTransmitting);
    }

    private get branchId() {
        return this.$store.getters["Auth/branchId"];
    }


    private get sendArticleEnabled(): boolean {
        return !this.isTransmitting;
    }

    private async checkTransmitting(): Promise<boolean> {
        const connectionState = await this.$ports.posManager.getConnectionStatus();
        return connectionState === 1;
    }
}
